export default {"src":"/_next/static/media/AIPredictionIcon.dc96a77b.svg","height":43,"width":55,"blurWidth":0,"blurHeight":0};